export default "__VITE_ASSET__B3B_H7Je__"